import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from 'axios';
import $ from 'jquery';
export default {
    data: function data() {
        return {
            person: {},
            locations: [],
            availableSearchBalance: -1,
            searchOwner: false,
            lastSearchType: ''
        };
    },
    asyncData: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                route = _ref.route;

            var _ref3, data;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return axios.get(global.getEndPoint() + 'api/person/' + route.params.id);

                        case 2:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            return _context.abrupt('return', {
                                person: data
                            });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function asyncData(_x) {
            return _ref2.apply(this, arguments);
        }

        return asyncData;
    }(),
    created: function created() {
        if (process.client) {
            this.lastSearchType = customSessionStorage.getItem('lastSearchType');
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (process.client) {
            var body = document.body; // Safari
            var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
            body.scrollTop = 0;
            html.scrollTop = 0;

            if (this.isLoggedIn()) {
                this.$auth.setAuthorizationHeaders();

                axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/person/full/' + this.$route.params.id).then(function (res) {
                    _this.person = res.data;
                    if (_this.person.search_owner == 1) {
                        _this.searchOwner = true;
                    }
                    if (_this.person.available_search_balance <= 0) {
                        _this.availableSearchBalance = -1;
                    } else {
                        if (!_this.person.result_found) {
                            _this.$router.push({ name: 'lang', params: { lang: _this.lang } });
                            return;
                        }
                        _this.availableSearchBalance = _this.person.available_search_balance;
                        var locations = [];
                        for (var i in _this.person.addresses) {
                            locations.push(_this.person.addresses[i].display);
                        }
                        _this.locations = locations;
                        if (locations.length) {
                            setTimeout(function () {
                                this.drawMap();
                            }.bind(_this), 3000);
                        }
                    }
                });
            }
        }
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        },
        websiteName: function websiteName() {
            var displayName = global.websiteSettings.extra_info.display_name;
            if (displayName) {
                return this.$root.trans('st_public.' + displayName);
            }
            return '';
        },
        showFullResult: function showFullResult() {
            return this.availableSearchBalance > 0 || this.searchOwner;
        }
    },
    head: function head() {
        return {
            titleTemplate: this.getTitle(),
            meta: [{ hid: 'description', name: 'description', content: this.getDescription() }, { hid: 'og:description', name: 'og:description', content: this.getDescription() }, { hid: 'og:title', name: 'og:title', content: this.getTitle() }]
        };
    },

    methods: {
        getTitle: function getTitle() {

            return this.$root._route.params.search.replace('-', ' ') + ' ' + this.$root.trans('st_public.profile') + ' - ' + this.$root.trans(global.websiteSettings.extra_info.title);
        },
        getDescription: function getDescription() {
            var address = '';
            if (this.$root._route.params.country) address = this.$root._route.params.country;
            if (this.$root._route.params.state) address += ' ' + this.$root._route.params.state;
            if (this.$root._route.params.city) address += ' ' + this.$root._route.params.city;
            /*console.log(this.$root.trans('st_public.profile_description_meta_tag',
                   {website:this.$root.trans(global.websiteSettings.extra_info.title),
                   name: this.$root._route.params.search.replace('-', ' ')
                   ,age:(this.person.dob?(' '+this.$root.trans('st_public.age_is') + ' ' + parseInt(this.person.dob.display)):'')
                   ,address:(address!=''?(' '+this.$root.trans('st_public.live_in') + ' ' + address):'')
               }));*/
            return this.$root.trans('st_public.profile_description_meta_tag', { website: this.$root.trans(global.websiteSettings.extra_info.title),
                name: this.$root._route.params.search.replace('-', ' '),
                age: this.person.dob ? this.$root.trans('st_public.age_is') + ' ' + parseInt(this.person.dob.display) : '',
                address: address != '' ? this.$root.trans('st_public.live_in') + ' ' + address : ''
            });
        },
        drawMap: function drawMap() {

            var map = new google.maps.Map(document.getElementById('user_addresses_map'), {
                center: new google.maps.LatLng(42.293564, -39.07617),
                zoom: 3,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            var infowindow = new google.maps.InfoWindow();

            var marker, i;

            //let bounds  = new google.maps.LatLngBounds();
            var geocoder = new google.maps.Geocoder();
            for (i = 0; i < this.locations.length; i++) {
                geocoder.geocode({ 'address': this.locations[i] }, function (results, status) {
                    if (status == 'OK') {
                        map.setCenter(results[0].geometry.location);
                        var marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location
                        });

                        //let loc = new google.maps.LatLng(marker.lat, marker.lng);
                        //bounds.extend(loc);
                    } else {
                        console.log('Geocode was not successful for the following reason: ' + status);
                    }
                });
            }
        },
        isLoggedIn: function isLoggedIn() {
            if (process.client && this.$auth.isAuthenticated()) {
                return true;
            }
            return false;
        },
        nameTrim: function nameTrim(name) {
            var display = '';
            display = name.first ? name.first + ' ' : '';
            display = name.middle ? display + name.middle + ' ' : display;
            display = name.last ? display + name.last : display;
            return display;
        },
        downloadPDF: function downloadPDF(e) {
            var id = this.person._id;
            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/person/print/' + id, {
                responseType: 'arraybuffer'
            }).then(function (response) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = id + '.pdf';
                link.click();
            });
        },
        unlockProfile: function unlockProfile() {
            if (typeof this.person.names[0] !== 'undefined' && typeof this.person.names[0].display !== 'undefined' && !customSessionStorage.getItem('lastSearchText')) {
                var searchHelper = new global.SearchHelper(this.person.names[0].display);
                searchHelper.setLastSearchMeta();
            }

            if (!this.$auth.isAuthenticated()) {
                global.dcbAbTestSearchButtonClick(this.$auth.isAuthenticated());
            } else {
                this.$router.push({
                    name: 'lang-signup',
                    params: {
                        lang: this.$route.params.lang
                    }
                });
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/_search/p/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/_search/p/_id.vue
// module chunks = 0